<template>
  <!-- 订单管理-充值订单 -->
  <div>
    <el-row class="table-header">
      <el-col style="width: 174px; margin-right: 20px">
        <el-select
          v-model="params.status"
          placeholder="订单状态"
          @change="handleSearch"
        >
          <el-option :value="undefined" label="全部订单状态"></el-option>
          <el-option :value="1" label="未支付"></el-option>
          <el-option :value="2" label="支付成功"></el-option>
        </el-select>
      </el-col>
      <el-col style="width: 174px; margin-right: 20px">
        <el-select
          v-model="params.pay_type"
          placeholder="支付类型"
          @change="handleSearch"
        >
          <el-option :value="undefined" label="全部支付类型"></el-option>
          <el-option :value="1" label="中兴支付app(支付宝)"></el-option>
          <el-option :value="2" label="微信"></el-option>
          <el-option :value="3" label="银联云闪付"></el-option>
          <el-option :value="4" label="CDkey充值"></el-option>
          <el-option :value="5" label="天宏卡密"></el-option>
          <el-option :value="6" label="聚合扫码"></el-option>
          <el-option :value="7" label="畅想发卡"></el-option>
          <el-option :value="8" label="掌宜付"></el-option>
          <el-option :value="9" label="特殊CDK"></el-option>
          <el-option :value="10" label="zhongxin(支付宝)"></el-option>
          <el-option :value="11" label="莫莫支付(支付宝)"></el-option>
          <el-option :value="12" label="莫莫支付(微信)"></el-option>
          <el-option :value="13" label="莫莫支付app(支付宝)"></el-option>
          <el-option :value="14" label="南山支付(支付宝)"></el-option>
          <el-option :value="15" label="南山支付app(支付宝)"></el-option>
          <el-option :value="16" label="南山支付(微信)"></el-option>
          <el-option :value="17" label="南山支付app(微信)"></el-option>
          <el-option :value="18" label="富信支付app(支付宝)"></el-option>
          <el-option :value="19" label="富信支付(支付宝)"></el-option>
          <el-option :value="20" label="九嘉支付(支付宝)"></el-option>
          <el-option :value="21" label="九嘉支付app(支付宝)"></el-option>
          <el-option :value="22" label="九嘉支付app2(支付宝)"></el-option>
          <el-option :value="24" label="莫莫支付(微信app)"></el-option>
          <el-option :value="26" label="汇眼达(支付宝)"></el-option>
          <el-option :value="27" label="汇眼达app(支付宝)"></el-option>
        </el-select>
      </el-col>
      <el-col style="width: 174px; margin-right: 20px">
        <el-select
          v-model="params.user_type"
          placeholder="用户类型"
          @change="handleSearch"
        >
          <el-option :value="1" label="全部订单"></el-option>
          <el-option :value="2" label="新用户订单"></el-option>
        </el-select>
      </el-col>
      <el-col style="width: 200px; margin-right: 20px">
        <el-input v-model="params.order_no" placeholder="订单号"></el-input>
      </el-col>
      <el-col style="width: 200px; margin-right: 20px">
        <el-input
          v-model="params.transaction_id"
          placeholder="第三方交易订单号"
        ></el-input>
      </el-col>
      <el-col style="width: 200px; margin-right: 20px">
        <el-input v-model="params.code" placeholder="推广码"></el-input>
      </el-col>
      <el-col style="width: 200px; margin-right: 20px">
        <el-input v-model="params.user_id" placeholder="用户id"></el-input>
      </el-col>
      <el-col style="width: 200px; margin-right: 20px">
        <el-input v-model="params.user_name" placeholder="用户名"></el-input>
      </el-col>
      <el-col style="width: 200px; margin-right: 20px">
        <el-input v-model="params.user_tag" placeholder="用户标签"></el-input>
      </el-col>
      <el-col style="width: 220px; margin-right: 20px">
        <el-date-picker
          v-model="params.pay_time_start"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择起始时间"
        >
        </el-date-picker>
      </el-col>
      <el-col style="width: 220px; margin-right: 20px">
        <el-date-picker
          v-model="params.pay_time_end"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择结束时间"
        >
        </el-date-picker>
      </el-col>
      <el-col style="width: 80px; margin-right: 20px">
        <el-button type="primary" @click="handleSearch" icon="el-icon-search"
          >搜索</el-button
        >
      </el-col>
      <el-col style="width: 80px; margin-right: 20px">
        <el-button style="margin-right: 20px" @click="handleExport"
          >导出</el-button
        >
      </el-col>
      <el-col style="width: 200px; margin-right: 20px">
        <span v-if="amount">总金额：{{ amount }}</span>
      </el-col>
    </el-row>
    <el-table v-loading="loading" :data="dataList">
      <el-table-column
        prop="order_no"
        label="充值订单号"
        width="240px"
      ></el-table-column>
      <el-table-column
        prop="transaction_id"
        label="第三方订单号"
        width="240px"
      ></el-table-column>
      <el-table-column label="用户">
        <template slot-scope="{ row }">
          <!-- <div class="user-avatar" v-if="row.user" @click="$router.push(`/user/${row.user_id}`)"> -->
          <div
            class="user-avatar"
            v-if="row.user"
            @click="pathToUser(row.user_id)"
          >
            <img :src="row.user.avatar || '/images/default-avatar.jpg'" alt />
            <span>{{ row.user.name }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="user.user_tag" label="用户标签"></el-table-column>
      <el-table-column
        prop="price"
        label="充值金额（实际）"
        sortable
      ></el-table-column>
      <el-table-column
        prop="dollar"
        label="到账金额（钻石）"
        sortable
      ></el-table-column>
      <el-table-column
        v-if="GLOBAL.kefu_flag"
        prop="pay_type"
        label="充值方式"
        :filters="[
          { text: '中兴支付app(支付宝)', value: 1 },
          { text: '微信', value: 2 },
          { text: '银联', value: 3 },
          { text: 'CDkey充值', value: 4 },
          { text: '天宏卡密', value: 5 },
          { text: '聚合扫码', value: 6 },
          { text: '畅想发卡', value: 7 },
          { text: '掌宜付', value: 8 },
          { text: '特殊CDK', value: 9 },
          { text: 'zhongxin(支付宝)', value: 10 },
          { text: '莫莫支付(支付宝)', value: 11 },
          { text: '莫莫支付(微信)', value: 12 },
          { text: '莫莫支付app(支付宝)', value: 13 },
          { text: '南山支付(支付宝)', value: 14 },
          { text: '南山支付app(支付宝)', value: 15 },
          { text: '南山支付(微信)', value: 16 },
          { text: '南山支付app(微信)', value: 17 },
          { text: '富信支付app(支付宝)', value: 18 },
          { text: '富信支付(支付宝', value: 19 },
          { text: '九嘉支付(支付宝', value: 20 },
          { text: '九嘉支付app(支付宝)', value: 21 },
          { text: '九嘉支付app2(支付宝)', value: 22 },
          { text: '莫莫支付(微信app)', value: 24 },
          { text: '汇眼达(支付宝)', value: 26 },
          { text: '汇眼达app(支付宝)', value: 27 },
        ]"
        :filter-method="filterPayType"
      >
        <template slot-scope="{ row }">
          <span v-if="row.pay_type === 1">中兴支付app(支付宝)</span>
          <span v-if="row.pay_type === 2">微信</span>
          <span v-if="row.pay_type === 3">银联</span>
          <span v-if="row.pay_type === 4">CDkey充值</span>
          <span v-if="row.pay_type === 5">天宏卡密</span>
          <span v-if="row.pay_type === 6">聚合扫码</span>
          <span v-if="row.pay_type === 7">畅想发卡</span>
          <span v-if="row.pay_type === 8">掌宜付</span>
          <span v-if="row.pay_type === 9">特殊CDK</span>
          <span v-if="row.pay_type === 10">zhongxin(支付宝)</span>
          <span v-if="row.pay_type === 11">莫莫支付(支付宝)</span>
          <span v-if="row.pay_type === 12">莫莫支付(微信)</span>
          <span v-if="row.pay_type === 13">莫莫支付app(支付宝)</span>
          <span v-if="row.pay_type === 14">南山支付(支付宝)</span>
          <span v-if="row.pay_type === 15">南山支付app(支付宝)</span>
          <span v-if="row.pay_type === 16">南山支付(微信)</span>
          <span v-if="row.pay_type === 17">南山支付app(微信)</span>
          <span v-if="row.pay_type === 18">富信支付app(支付宝)</span>
          <span v-if="row.pay_type === 19">富信支付(支付宝)</span>
          <span v-if="row.pay_type === 20">九嘉支付(支付宝)</span>
          <span v-if="row.pay_type === 21">九嘉支付app(支付宝)</span>
          <span v-if="row.pay_type === 22">九嘉支付app2(支付宝)</span>
          <span v-if="row.pay_type === 24">莫莫支付(微信app)</span>
          <span v-if="row.pay_type === 26">汇眼达(支付宝)</span>
          <span v-if="row.pay_type === 27">汇眼达app(支付宝)</span>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="推广码" sortable></el-table-column>
      <el-table-column
        prop="pay_time"
        label="充值时间"
        sortable
      ></el-table-column>
      <el-table-column
        prop="status"
        label="订单状态"
        :filters="[
          { text: '未支付', value: 1 },
          { text: '充值成功', value: 2 },
        ]"
        :filter-method="filterStatus"
      >
        <template slot-scope="{ row }">
          <el-tag type="info" v-if="row.status === 1">未支付</el-tag>
          <el-tag type="success" v-if="row.status === 2">充值成功</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="" label="备注" sortable>
        <template slot-scope="{ row }">
          {{ row.coupon_record_able && row.coupon_record_able.remark }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :page-size="dataMeta.per_page || 15"
      :total="dataMeta.total || 0"
      :current-page="params.page"
      @current-change="handlePageChange"
    ></el-pagination>
  </div>
</template>

<script>
import http, { getData, server } from '../../http'
import saveFile from '../../utils/saveFile'

export default {
  props: {
    id: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      dataList: undefined,
      dataMeta: {},
      amount: undefined,
      loading: false,
      params: {
        page: 1,
        status: 2,
        code: undefined,
        pay_type: undefined,
        user_type: 1,
        pay_time_start: undefined,
        pay_time_end: undefined,
        user_id: undefined,
        user_name: undefined,
        order_no: '',
        user_tag: '',
        transaction_id: ''
      }
    }
  },

  methods: {
    getTableData() {
      this.loading = true
      getData(`recharge`, { ...this.params })
        .then(res => {
          this.dataList = res.data
          this.amount = res.amount
          this.dataMeta = res.meta
        })
        .finally(() => {
          this.loading = false
        })
    },
    handlePageChange(page) {
      this.params.page = page
      this.getTableData()
    },
    handleSearch() {
      this.params.page = 1
      this.getTableData()
    },
    handleExport() {
      http
        .post(
          server + 'recharge_extract',
          { ...this.params, page: undefined },
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '充值订单记录.xlsx'
          })
        })
    },
    pathToUser(id) {
      let routeData = this.$router.resolve({ path: `/user/${id}` })
      window.open(routeData.href, '_blank')
    },
    filterPayType(value, row, column) {
      //筛选充值方式
      const property = column['property'];
      return row[property] === value;
    },
    filterStatus(value, row, column) {
      //筛选订单状态
      const property = column['property'];
      return row[property] === value;
    },
  },
  created() {
    this.getTableData()
  }
}
</script>

<style>
</style>
